export default __webpack_public_path__ + "static/media/logo-metro.61ab33bc.svg";